import { create } from "zustand";
import axios from "axios";
import dayjs from "dayjs";

interface ParticipantCount {
    leaders: number;
    followers: number;
    pairs: number;
    leadersInQueue: number;
    followersInQueue: number;
    pairsInQueue: number;
    total: number;
}

interface Subevent {
    id: number | null;
    eventId: number;
    name: string;
    description: string;
    balancingBuffer: number;
    isBalanced: boolean;
    maxParticipants: number;
    date: string;
    startTime: string;
    endTime: string;
    trainer: string;
    price: number;
    individualPrice: number;
    module: boolean;
    isParty: boolean;
    participantCount: ParticipantCount;
    tags: string[];
    onlyWithPartner: boolean;
}

interface SubeventStore {
    subevents: Subevent[];
    fetchAndSetSubevents: (eventId: number, onError: (err: any) => void) => Promise<Subevent[]>;
    updateSubevents: (eventId: number, onError: (err: any) => void) => Promise<Subevent[]>;
    loading: boolean;
}

async function fetchSubevents(eventId: number, onError: (err: any) => void): Promise<Subevent[]> {
    let subevents = null;

    try {
        const res = await axios.get(`wp-json/tts-booking/v1/events/subevents?eventId=${eventId}`)
        subevents = res.data;
    } catch (err) {
        onError(err);
        return Promise.reject();
    }


    // Sort events by start date and start time
    subevents.sort((a: Subevent, b: Subevent) => {
        let aDate = dayjs(a.date + " " + a.startTime);
        let bDate = dayjs(b.date + " " + b.startTime);
        if (aDate.isBefore(bDate)) {
            return -1;
        } else if (aDate.isAfter(bDate)) {
            return 1;
        } else {
            return 0;
        }
    });

    return subevents;
}


export const useSubevents = create<SubeventStore>((set, get) => ({
    subevents: [],
    fetchAndSetSubevents: async (eventId: number, onError: (err: any) => void) => {
        set({ loading: true })
        try {
            let subevents = await fetchSubevents(eventId, onError);

            set({ subevents: subevents });
            set({ loading: false });

            return Promise.resolve(subevents);
        } catch (err) {
            set({ loading: false })
        }
        return Promise.resolve([]);
    },
    updateSubevents: async (eventId: number, onError: (err: any) => void) => {
        set({ loading: true })
        try {
            let subevents = await fetchSubevents(eventId, onError);

            set({ subevents: subevents });
            set({ loading: false });

            return Promise.resolve(subevents);
        } catch (err) {
            set({ loading: false });
        }
        return Promise.resolve([]);
    },
    loading: true
}));


export type { Subevent };
